<!-- <div *ngIf="loadingService.getLoadingState()" class="color-blue">
    <div class="flex-v-center loading">
        <span nz-icon nzType="loading" nzTheme="outline"></span>
        <div class="">Loading...</div>
    </div>
    
</div> -->
<nz-spin nzTip="" [nzSpinning]="loadingService.getLoadingState()"></nz-spin>
